import { raw, ObservableStore, tracked } from 'packages/observable-store'

export const store = new ObservableStore()
export { raw }

export const standardSettings = {
    allLists: {},
    allSearches: {},
    hideResults: false,
    contractor: tracked({}),
    supplier: tracked({}),
    contractorName: '',
    contractorStatus: '',
    currentContractorTab: 0,
    currentList: '',
    currentListItem: null,
    currentListTitle: '',
    currentReportingTab: 0,
    currentSearch: {},
    display: tracked({
        firstRow: 1,
    }),
    expanded: {},
    listCategory: 'Assets',
    metadata: {},
    mode: 'card',
    contractorType: '',
    options: {
        __anchored: true,
        choices: [],
        ss_choices: [],
        location: false,
        onSilver: true,
        'Sustainability-switch-bronze': false,
        'Sustainability-switch-gold': false,
        'Sustainability-switch-notverified': false,
        'Sustainability-switch-silver': false,
        'Policies-switch-environmental': false,
        'Policies-switch-environmentalno': false,
        'Policies-switch-modernslavery': false,
        'Policies-switch-modernslaveryno': false,
        'Policies-switch-antibribery': false,
        'Policies-switch-antibriberyno': false,
        'Policies-switch-gdpr': false,
        'Policies-switch-gdprno': false,
        'Policies-switch-qualitymanagement': false,
        'Policies-switch-qualitymanagementno': false,
        suppliers: true,
        contractors: true,
    },
    aweEditType: '',
    postcode: '',
    results: {},
    search: tracked({
        input: '',
    }),
    searching: 0,
    searchOptions: {},
    selected: {},
    settings: tracked({
        displayRows: 50,
        sort: '-v', // Relevance
    }),
    userLists: {},
}

store.set(standardSettings)

export function searchSettings() {
    let result = {
        search: store.search$.input$,
        settings: {
            displayRows: store.settings$.displayRows$,
            sort: store.settings$.sort$,
        },
        options: store.options$,
        display: { firstRow: store.display$.firstRow$ },
        userLists: store.userLists$,
        postcode: store.postcode$,
        searchOptions: store.searchOptions$,
        mode: store.mode$,
    }
    let options = result.searchOptions || {}
    delete options.bitmaps
    delete options.tabulations
    delete options.hydrate
    delete options.skip
    delete options.take
    delete options.sort
    return result
}

export function setSearchSettings(saved) {
    if (!saved) return
    store.search.value.input.value = saved?.search || ''
    store.settings.value.displayRows.value =
        saved?.settings?.displayRows || store.settings.value.displayRows.value || ''
    store.settings.value.sort.value = saved?.settings?.sort || store.settings.value.sort.value || ''
    store.options.value = saved?.options || store.options.value || ''
    store.userLists.value = saved?.userLists || store.userLists.value || ''
    store.postcode.value = saved?.postcode || ''
    store.searchOptions.value = saved?.searchOptions || store.searchOptions.value || ''
    store.mode.value = saved?.mode || ''
    store.display.value.firstRow.value = saved?.display?.firstRow || ''
}

export const resetSearchSettings = ({ suppliers = true, contractors = true, anchored = true }) => {
    setSearchSettings({
        currentSearch: {},
        display: {
            firstRow: 1,
        },
        expanded: {},
        listCategory: 'Assets',
        metadata: {},
        mode: 'card',
        options: {
            __anchored: anchored,
            __masterlist: true,
            choices: [],
            ss_choices: [],
            location: false,
            onSilver: true,
            'Sustainability-switch-bronze': false,
            'Sustainability-switch-gold': false,
            'Sustainability-switch-notverified': false,
            'Sustainability-switch-silver': false,
            'Policies-switch-environmental': false,
            'Policies-switch-environmentalno': false,
            'Policies-switch-modernslavery': false,
            'Policies-switch-modernslaveryno': false,
            'Policies-switch-antibribery': false,
            'Policies-switch-antibriberyno': false,
            'Policies-switch-gdpr': false,
            'Policies-switch-gdprno': false,
            'Policies-switch-qualitymanagement': false,
            'Policies-switch-qualitymanagementno': false,
            targetPostcode: false,
            suppliers,
            contractors,
        },
        postcode: '',
        results: {},
        search: '',
        searching: 0,
        searchOptions: {},
        selected: {},
        settings: {
            displayRows: 50,
            sort: '-v', // Relevance
        },
        userLists: {},
    })
}

export function track() {}

window.dumpCPStore = () => store
window.settings = () => searchSettings()
